/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptWinbackRequest,
  CancellationRequestResponse,
  CreateCancellationRequestRequest,
  DeclineWinbackRequest,
  EnhancedSubscriptionResponse,
  HTTPValidationError,
  WinbackPricingResponse
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get the current subscription for the authenticated member.

Returns subscription with enhanced status:
- If no cancellation request exists: returns original status
- If active cancellation request exists: returns status as "cancellation_pending"
- If resolved cancellation request exists: returns original status
 * @summary Get Subscriptions
 */
export const getSubscriptionsV1SubscriptionsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<EnhancedSubscriptionResponse>(
      {url: `/v1/subscriptions`, method: 'GET', signal
    },
      );
    }
  

export const getGetSubscriptionsV1SubscriptionsGetQueryKey = () => {
    return [`/v1/subscriptions`] as const;
    }

    
export const getGetSubscriptionsV1SubscriptionsGetQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionsV1SubscriptionsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>> = ({ signal }) => getSubscriptionsV1SubscriptionsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSubscriptionsV1SubscriptionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>>
export type GetSubscriptionsV1SubscriptionsGetQueryError = unknown


export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>,
          TError,
          Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Subscriptions
 */

export function useGetSubscriptionsV1SubscriptionsGet<TData = Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionsV1SubscriptionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSubscriptionsV1SubscriptionsGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create Cancellation Request
 */
export const createCancellationRequestV1SubscriptionCancellationRequestsPost = (
    createCancellationRequestRequest: CreateCancellationRequestRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<CancellationRequestResponse>(
      {url: `/v1/subscription-cancellation-requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCancellationRequestRequest, signal
    },
      );
    }
  


export const getCreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, TError,{data: CreateCancellationRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, TError,{data: CreateCancellationRequestRequest}, TContext> => {

const mutationKey = ['createCancellationRequestV1SubscriptionCancellationRequestsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, {data: CreateCancellationRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  createCancellationRequestV1SubscriptionCancellationRequestsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>>
    export type CreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationBody = CreateCancellationRequestRequest
    export type CreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationError = HTTPValidationError

    /**
 * @summary Create Cancellation Request
 */
export const useCreateCancellationRequestV1SubscriptionCancellationRequestsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>, TError,{data: CreateCancellationRequestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCancellationRequestV1SubscriptionCancellationRequestsPost>>,
        TError,
        {data: CreateCancellationRequestRequest},
        TContext
      > => {

      const mutationOptions = getCreateCancellationRequestV1SubscriptionCancellationRequestsPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Get pricing information for the winback discount offer.

Returns original price, discount amount, and final price after discount.
Only available for subscriptions with pending cancellation requests that
haven't previously used the winback offer.
 * @summary Get Winback Pricing
 */
export const getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet = (
    stripeSubscriptionId: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<WinbackPricingResponse>(
      {url: `/v1/subscription-cancellation-requests/${stripeSubscriptionId}/winback-pricing`, method: 'GET', signal
    },
      );
    }
  

export const getGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryKey = (stripeSubscriptionId?: string,) => {
    return [`/v1/subscription-cancellation-requests/${stripeSubscriptionId}/winback-pricing`] as const;
    }

    
export const getGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryOptions = <TData = Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError = HTTPValidationError>(stripeSubscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryKey(stripeSubscriptionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>> = ({ signal }) => getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet(stripeSubscriptionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(stripeSubscriptionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryResult = NonNullable<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>>
export type GetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryError = HTTPValidationError


export function useGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet<TData = Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError = HTTPValidationError>(
 stripeSubscriptionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>,
          TError,
          Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet<TData = Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError = HTTPValidationError>(
 stripeSubscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>,
          TError,
          Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet<TData = Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError = HTTPValidationError>(
 stripeSubscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Winback Pricing
 */

export function useGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet<TData = Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError = HTTPValidationError>(
 stripeSubscriptionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWinbackPricingV1SubscriptionCancellationRequestsStripeSubscriptionIdWinbackPricingGetQueryOptions(stripeSubscriptionId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Accept the winback discount offer.

Applies the discount coupon to the subscription and updates the
cancellation request outcome to WONBACK. The subscription will continue
with the discount applied to the next billing cycle.
 * @summary Accept Winback Offer
 */
export const acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost = (
    acceptWinbackRequest: AcceptWinbackRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<CancellationRequestResponse>(
      {url: `/v1/subscription-cancellation-requests/accept-winback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptWinbackRequest, signal
    },
      );
    }
  


export const getAcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>, TError,{data: AcceptWinbackRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>, TError,{data: AcceptWinbackRequest}, TContext> => {

const mutationKey = ['acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>, {data: AcceptWinbackRequest}> = (props) => {
          const {data} = props ?? {};

          return  acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPostMutationResult = NonNullable<Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>>
    export type AcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPostMutationBody = AcceptWinbackRequest
    export type AcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPostMutationError = HTTPValidationError

    /**
 * @summary Accept Winback Offer
 */
export const useAcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>, TError,{data: AcceptWinbackRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPost>>,
        TError,
        {data: AcceptWinbackRequest},
        TContext
      > => {

      const mutationOptions = getAcceptWinbackOfferV1SubscriptionCancellationRequestsAcceptWinbackPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Decline the winback discount offer and proceed with cancellation.

Disables auto-renewal on the subscription and updates the cancellation
request outcome to CANCELLED. The subscription will end at the current
period end.
 * @summary Decline Winback Offer
 */
export const declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost = (
    declineWinbackRequest: DeclineWinbackRequest,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<CancellationRequestResponse>(
      {url: `/v1/subscription-cancellation-requests/decline-winback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: declineWinbackRequest, signal
    },
      );
    }
  


export const getDeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>, TError,{data: DeclineWinbackRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>, TError,{data: DeclineWinbackRequest}, TContext> => {

const mutationKey = ['declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>, {data: DeclineWinbackRequest}> = (props) => {
          const {data} = props ?? {};

          return  declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPostMutationResult = NonNullable<Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>>
    export type DeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPostMutationBody = DeclineWinbackRequest
    export type DeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPostMutationError = HTTPValidationError

    /**
 * @summary Decline Winback Offer
 */
export const useDeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>, TError,{data: DeclineWinbackRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof declineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPost>>,
        TError,
        {data: DeclineWinbackRequest},
        TContext
      > => {

      const mutationOptions = getDeclineWinbackOfferV1SubscriptionCancellationRequestsDeclineWinbackPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    